import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';

/**
 * Centralized asset loading configuration.
 * Draco decoder configured for compressed geometry.
 * KTX2 skipped for v1 (no .ktx2 textures yet).
 *
 * Two separate LoadingManagers: one for exterior (drives preloader UI),
 * one for interior (silent background load).
 */

let dracoLoader: DRACOLoader | null = null;
let exteriorGltfLoader: GLTFLoader | null = null;
let interiorGltfLoader: GLTFLoader | null = null;

// Exterior loading manager — drives the preloader UI
export const exteriorLoadManager = new THREE.LoadingManager();
export const interiorLoadManager = new THREE.LoadingManager();

let interiorReady = false;

interiorLoadManager.onLoad = () => {
  interiorReady = true;
};

export function isInteriorReady(): boolean {
  return interiorReady;
}

export function initLoaders(): void {
  // Draco decoder — shared instance
  dracoLoader = new DRACOLoader();
  dracoLoader.setDecoderPath('/draco/');

  // Exterior GLTF loader
  exteriorGltfLoader = new GLTFLoader(exteriorLoadManager);
  exteriorGltfLoader.setDRACOLoader(dracoLoader);

  // Interior GLTF loader
  interiorGltfLoader = new GLTFLoader(interiorLoadManager);
  interiorGltfLoader.setDRACOLoader(dracoLoader);
}

export function getExteriorLoader(): GLTFLoader {
  if (!exteriorGltfLoader) throw new Error('Loaders not initialized. Call initLoaders() first.');
  return exteriorGltfLoader;
}

export function getInteriorLoader(): GLTFLoader {
  if (!interiorGltfLoader) throw new Error('Loaders not initialized. Call initLoaders() first.');
  return interiorGltfLoader;
}
